export class State {
  id!: number;
  name!: string;
  description!: string;
}
